import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      color: COLORS.gray.white,
    },
    meter: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 160,
      // Vertical separator between the two side-by-side meters in the nav bar. Keep the
      // padding tight so the progress bar does not leave a dead zone before the divider.
      '&:not(:last-child)': {
        paddingRight: theme.spacing(1.5),
        borderRight: `1px solid ${COLORS.neutral.darkGray}`,
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
    },
    title: {},
    countWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    count: {},
    information: {},
    linearProgress: {
      backgroundColor: COLORS.neutral.mediumLightGray,
      height: 4,
    },
    bar: {
      backgroundColor: COLORS.success.default,
    },
    limitBar: {
      backgroundColor: COLORS.error.active,
    },
  }),
  { name: 'TrialUsageMeters' }
);
